// rootReducer.js
import { combineReducers } from 'redux';
import authReducer from './authReducer'; // Seu reducer de autenticação

const rootReducer = combineReducers({
  auth: authReducer,
  // Outros reducers da sua aplicação
});

export default rootReducer;